import { render, staticRenderFns } from "./medicalBooking.vue?vue&type=template&id=099fdf9f&scoped=true&"
import script from "./medicalBooking.vue?vue&type=script&lang=js&"
export * from "./medicalBooking.vue?vue&type=script&lang=js&"
import style0 from "./medicalBooking.vue?vue&type=style&index=0&id=099fdf9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099fdf9f",
  null
  
)

export default component.exports